import HotTourWidget from './HotTourWidget';

export default HotTourWidget;
